import styled from "@mui/material/styles/styled";

import Button from "@rui/Button";
import TooltipIcon from "@rui/TooltipIcon";
import TooltipWrapper from "@rui/TooltipWrapper";

const DEFAULT_CALENDAR_TOOLTIP =
  "Your default calendar provider is used for Smart Scheduler availability and scheduling. If you have multiple calendars synced, it will only use your primary calendar.";

const DefaultButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[300],
  color: theme.palette.shades.primary[500],
  boxShadow: "none",
  "&:hover": {
    cursor: "default",
    backgroundColor: theme.palette.shades.ghost[300],
    color: theme.palette.shades.primary[500],
    boxShadow: "none",
  },
}));

const SetAsDefaultButton = styled(Button)(({ theme }) => ({
  borderColor: theme.palette.shades.neutral[100],
}));

const DefaultCalendarButton = ({
  disabled,
  isDefault,
  onClick,
  show,
}: {
  disabled: boolean;
  isDefault: boolean;
  onClick: () => void;
  show: boolean;
}) => {
  if (!show) return null;

  if (isDefault) {
    return (
      <DefaultButton endIcon={<TooltipIcon title={DEFAULT_CALENDAR_TOOLTIP} />}>
        Default Calendar
      </DefaultButton>
    );
  }

  return (
    <TooltipWrapper
      title="At least one calendar must be enabled"
      show={disabled}
    >
      <SetAsDefaultButton
        variant="outlined"
        endIcon={<TooltipIcon title={DEFAULT_CALENDAR_TOOLTIP} />}
        onClick={onClick}
        disabled={disabled}
      >
        Set as default calendar
      </SetAsDefaultButton>
    </TooltipWrapper>
  );
};

export default DefaultCalendarButton;
